import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { translate } from 'loankeeper-common/helpers'

import FakeInput from './FakeInput'

const AccountTitle: FC<{
  name: string
  FormName: string
}> = ({ name, FormName }) => {
  const text: string = useSelector((state) => formValueSelector(FormName)(state, name) || '')

  return <FakeInput>{text.trim() !== '' ? text : translate('frm_account_select-pan_notfound')}</FakeInput>
}

export default AccountTitle
